import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { injectIntl } from 'react-intl';
import { hasErrors } from 'HELPERS/utils';
import { saveResource } from 'ACTIONS/resources.actions';
import { Form, Button, Icon, message, DatePicker } from 'antd';

class ScheduleDateForm extends Component {
  componentDidMount() {
    // disable form without submitting a date
    this.props.form.validateFields();
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields(async (err, values) => {
      if (!err) {
        try {
          const { datePicker } = values;
          const data = {
            name: 'next_newsletter_date',
            value: datePicker.format('YYYY-MM-DD'),
          };
          await this.props.saveResource('settings', data);
          const successMessage = `The newsletter date has been set to ${moment(datePicker).format('MMM DD, YYYY')}`;
          message.success(successMessage, 5);
        } catch (error) {
          // What else we can do here?
        }
      }
    });
  };

  render() {
    const { isSaving, intl, settings } = this.props;

    const {
      getFieldDecorator,
      getFieldsError,
      isFieldTouched,
      getFieldError,
    } = this.props.form;
    const dateFormat = 'MMM DD, YYYY';
    const dateError = isFieldTouched('datePicker') && getFieldError('datePicker');
    const disabledDate = current => (current && current < moment().endOf('day'));

    if (this.props.isCompleted) {
      return (
        <Form className="newsletter-date-form" onSubmit={this.handleSubmit} disabled={isSaving} layout="inline">
          <div>
            <Form.Item
              label={intl.formatMessage({ id: 'date.newsletterDateLabel' })}
              colon={false}
              validateStatus={dateError ? 'error' : ''}
              help={dateError || ''}
            >
              {getFieldDecorator('datePicker', {
                rules: [{
                  required: true,
                  message: 'Please select a date!',
                }],
                initialValue: settings.data.find(setting => setting.name === 'next_newsletter_date') ? moment(settings.data.find(setting => setting.name === 'next_newsletter_date').value, 'YYYY-MM-DD') : null,
              })(
                <DatePicker
                  format={dateFormat}
                  disabledDate={disabledDate}
                />
              )}
            </Form.Item>
            <Form.Item>
              {intl.formatMessage({ id: 'date.time' })}
            </Form.Item>
            <Form.Item>
              <Button type="primary" htmlType="submit" disabled={isSaving || hasErrors(getFieldsError())}>
                <Icon type={isSaving ? 'loading' : 'check-circle-o'} />
                Save
              </Button>
            </Form.Item>
          </div>
        </Form>
      );
    }
    return null;
  }
}

ScheduleDateForm.defaultProps = {
  isSaving: false,
  isCompleted: false,
};

ScheduleDateForm.propTypes = {
  isSaving: PropTypes.bool,
  isCompleted: PropTypes.bool,
  intl: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired,
  settings: PropTypes.object.isRequired,
  // functions
  saveResource: PropTypes.func.isRequired,
};

const mapStateToProps = ({ resources }, ownProps) => ({
  isSaving: resources[ownProps.resource].isSaving,
  isCompleted: resources[ownProps.resource].isCompleted,
  settings: resources.settings,
});

const enhanced = compose(
  Form.create(),
  connect(mapStateToProps, { saveResource }),
  injectIntl
);

export default enhanced(ScheduleDateForm);



// WEBPACK FOOTER //
// ./src/pages/Control/Screens/ScheduleDate/ScheduleDateForm.js